// Utils
import { getCommitted } from './getCommitted';
/**
 * Describes whether a committable object has uncommitted changes
 *
 * @param values {Committable<any>}
 *
 * @return {boolean}
 */
export var hasUncommitted = function (values) {
    var committed = getCommitted(values);
    return committed !== values;
};
//# sourceMappingURL=hasUncommited.js.map